import { ReactNode } from 'react';

import { getPathnameByType, ROUTE_PAGE } from '$routes';
import RouterLink from '~components/generic/RouterLink';

export type LinkProps = {
  href: string;
  children?: ReactNode;
  className?: string;
  lang?: string;
};

export const Link = ({ href, children, className }: LinkProps) => {
  return (
    <RouterLink className={className} to={{ pathname: getPathnameByType(ROUTE_PAGE, { pageAlias: href }) }}>
      {children}
    </RouterLink>
  );
};
